import React from 'react';
import Cookies from 'js-cookie';

const setTarget = (googletag) => {
  googletag.pubads().enableSingleRequest();
  googletag.enableServices();
};

interface IProps {
  slot: any;
  width: any;
  height: any;
  styles?: any;
}

class AdIframe extends React.PureComponent<IProps> {
  componentDidMount() {
    const { slot, width, height } = this.props;
    try {
      window.googletag.cmd.push(function () {
        window.googletag.defineSlot(slot, [width, height], slot).addService(window.googletag.pubads());

        setTarget(window.googletag);
        const buycar_stage = localStorage.getItem('buycar_stage');
        window.googletag.pubads().setTargeting('buycar_stage', buycar_stage);
        if (Cookies.get('appversion') == 'debug' || Cookies.get('adtest') == 'true') {
          window.googletag.pubads().setTargeting('debug', '1');
        }
        window.googletag.display(slot);
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { slot, styles } = this.props;

    return (
      <div id={slot} style={{ width: 0, height: 0, position: 'relative', zIndex: -1, overflow: 'hidden', ...styles }} />
    );
  }
}

export default AdIframe;
